import { render, staticRenderFns } from "./set-permision.vue?vue&type=template&id=7002e5b8&scoped=true&"
import script from "./set-permision.vue?vue&type=script&lang=ts&"
export * from "./set-permision.vue?vue&type=script&lang=ts&"
import style0 from "./set-permision.vue?vue&type=style&index=0&id=7002e5b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002e5b8",
  null
  
)

export default component.exports